// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_VQj","cls2":"common-cls2_RtC common-cls1_VQj"};